import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { SinapiItemDto } from '../api/Manipulate/Sinapi';

@Injectable({
  providedIn: 'root'
})
export class CsvReaderService {

  convertSinapiExcelToJson(file: File): Promise<{ items: SinapiItemDto[] }> {
    return new Promise((resolve, reject) => {
      const STATES = ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
                      'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN',
                      'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          const sheetNameSem = workbook.SheetNames.find(n => n.includes('ISD')) || workbook.SheetNames[0];
          const sheetNameCom = workbook.SheetNames.find(n => n.includes('ICD')) || workbook.SheetNames[1];

          const sheetCom = workbook.Sheets[sheetNameCom];
          const sheetSem = workbook.Sheets[sheetNameSem];

          const dataCom: any[] = XLSX.utils.sheet_to_json(sheetCom, { range: 9 });
          const dataSem: any[] = XLSX.utils.sheet_to_json(sheetSem, { range: 9 });

          // Detecta nomes reais das colunas (evita problema com \n vs \r\n)
          const firstRow = dataCom[0] || {};
          const keys = Object.keys(firstRow);
          const COL_COD   = keys.find(k => k.includes('Código'))    || 'Código do\r\nInsumo';
          const COL_DESC  = keys.find(k => k.includes('Descrição')) || 'Descrição do Insumo';
          const COL_TIPO  = keys.find(k => k.includes('Classif'))   || 'Classificação';
          const COL_UNIT  = keys.find(k => k.includes('Unidade'))   || 'Unidade';
          const COL_ORIG  = keys.find(k => k.includes('Origem'))    || 'Origem de\r\nPreço';

          const itemsMap = new Map<string, SinapiItemDto>();

          // 1. Processar Aba COM Desoneração — todos os estados iniciam com null
          dataCom.forEach((row) => {
            const cod = String(row[COL_COD] || '').trim();
            if (!cod || cod === 'undefined') return;

            const item: SinapiItemDto = {
              type: row[COL_TIPO] || 'Insumo',
              cod: cod,
              description: row[COL_DESC] || '',
              unitMeasure: row[COL_UNIT] || '',
              priceOrigin: row[COL_ORIG] || 'SINAPI',
              prices: {}
            };

            STATES.forEach(uf => {
              item.prices[uf] = {
                withDesoner: (row[uf] != null) ? this.parseNumber(row[uf]) : null,
                withoutDesonr: null  // preenchido no cruzamento com ISD
              };
            });

            itemsMap.set(cod, item);
          });

          // 2. Cruzar com Aba SEM Desoneração
          dataSem.forEach((row) => {
            const cod = String(row[COL_COD] || '').trim();
            const existingItem = itemsMap.get(cod);
            if (!existingItem) return;

            STATES.forEach(uf => {
              existingItem.prices[uf].withoutDesonr = (row[uf] != null)
                ? this.parseNumber(row[uf])
                : null;
            });
          });

          resolve({ items: Array.from(itemsMap.values()) });

        } catch (error) {
          reject('Erro ao processar o Excel: ' + error);
        }
      };

      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  }

  private parseNumber(value: any): number {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') return parseFloat(value.replace(',', '.'));
    return 0;
  }
}